import { render, staticRenderFns } from "./JsonFormatter.vue?vue&type=template&id=17c56876&scoped=true"
import script from "./JsonFormatter.vue?vue&type=script&lang=js"
export * from "./JsonFormatter.vue?vue&type=script&lang=js"
import style0 from "./JsonFormatter.vue?vue&type=style&index=0&id=17c56876&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c56876",
  null
  
)

export default component.exports